import { useTranslation } from 'react-i18next';
import { Button } from '@scio3/ui';
import { type PageSuggestion } from '../utils/page-suggestions';

interface OptiBotSuggestionsProps {
  suggestions: PageSuggestion[];
  onSuggestionClick: (question: string) => void;
}

/**
 * Contextual suggestion pills shown below the welcome message.
 * Each pill sends a pre-defined question to OptiBot when clicked.
 * Rendered as compact, rounded pills that wrap naturally.
 */
export function OptiBotSuggestions({ suggestions, onSuggestionClick }: OptiBotSuggestionsProps) {
  const { t } = useTranslation();

  if (suggestions.length === 0) return null;

  return (
    <div className="space-y-1.5">
      <p className="text-xs font-medium text-muted-foreground">{t('optibot.commonQuestions')}</p>
      <div className="flex flex-wrap gap-2">
        {suggestions.map((suggestion) => (
          <Button
            key={suggestion.labelKey}
            variant="outline"
            size="sm"
            onClick={() => onSuggestionClick(suggestion.question)}
            className="rounded-full px-3 py-1.5 text-xs shadow-sm"
          >
            {t(suggestion.labelKey)}
          </Button>
        ))}
      </div>
    </div>
  );
}
